import { createContext } from 'react';

import type { PublishedLocaleManifest } from '@/i18n/types';

export interface LocaleContextValue {
    manifest: PublishedLocaleManifest;
    locale: string;
    pageContent?: Record<string, Record<string, Record<string, unknown>>>;
}

export const LocaleContext = createContext<LocaleContextValue | null>(null);
